import script from "./PCInformationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PCInformationBar.vue?vue&type=script&setup=true&lang=js"

import "./PCInformationBar.vue?vue&type=style&index=0&id=267e755a&lang=css"
import "./PCInformationBar.vue?vue&type=style&index=1&id=267e755a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267e755a"]])

export default __exports__